import React, { useState } from "react";
import {Link } from 'react-router-dom'
import axiosInstance from "../../services/api";
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../Commons/Loader';
function ChangePassword() {
  const history = useHistory();
    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState(""); 
    const [errorMessage, setErrorMessage] = useState(""); 
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setNewShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        id:null,
        currentpassword: "",
        newpassword: "",
        confirmnewpassword: "",
    });

    const validate = () => {
        let tempErrors = {};
        let isValid = true;
    
        // Strong password regex pattern
        const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
        
        if (!formData.currentpassword) {
            tempErrors.currentpassword = "Please enter a current password";
            isValid = false;
        }

        if (!formData.newpassword) {
            tempErrors.newpassword = "Please enter a new password";
            isValid = false;
        } else if (!passwordPattern.test(formData.newpassword)) {
            tempErrors.newpassword = "Password must be at least 8 characters, include uppercase, lowercase, number, and special character";
            isValid = false;
        }
    
        if (!formData.confirmnewpassword) {
            tempErrors.confirmnewpassword = "Please confirm your new password";
            isValid = false;
        } else if (formData.newpassword !== formData.confirmnewpassword) {
            tempErrors.confirmnewpassword = "New password and confirm password do not match";
            isValid = false;
        }
    
        setErrors(tempErrors);
        return isValid;
    };
    
    

  const handleChange = (e) => {
   
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setSuccessMessage(""); // Clear success message on input chang
  };

  const handleSubmit = async (e) => {
    toast.dismiss();
    e.preventDefault();

    if (validate()) {
        setLoading(true);
    try {
        const { confirmPassword, selectGroup, ...filteredFormData } = formData;
        const payload = {
            oldPassword: formData.currentpassword,
            newPassword: formData.newpassword // Fixed key name here
        };
        const response = await axiosInstance.post('user/change-password', payload);
        if (response.status === 200) {
            if(response.data.status.code===200) {
                //setSuccessMessage(response.data.status.message);
                toast.success(response.data.status.message);
                setFormData({ newpassword: "", confirmnewpassword: "", currentpassword:"" });
            }else{
                //setErrorMessage(response.data.status.message)
                toast.error(response.data.status.message);
            }

            // setTimeout(() => {
            //     setSuccessMessage("");
            //     setErrorMessage("");
            //     //history.push('/dashboard'); 
            // }, 2000);
        }
        } catch (error) {
        console.error('Error validating OTP:', error);
        }
        finally {
            setLoading(false);
          }
    }
  };



    return (
        <>
            {loading && <Loader />} 

            <div className="content-header">
                <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6">
                    <h1 className="m-0">Change Password</h1>
                    </div>{/* /.col */}
                    <div className="col-sm-6">
                    <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                        <li className="breadcrumb-item active">Change Password</li>
                    </ol>
                    </div>{/* /.col */}
                </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <div className="change-password-wrapper">
                        <form className="row">
                            <div className="col-12">
                                <div className="form-group pos-rel-change">
                                    <label>Current Password <span>*</span></label>
                                    <input type={showPassword ? "text" : "password"} className="input-fld" name="currentpassword" value={formData.currentpassword} onChange={handleChange}  />
                                    <a className='see-password' onClick={() => setShowPassword((prev) => !prev)}> {showPassword ? <i className="nav-icon fas fa-eye-slash" /> : <i className="nav-icon fas fa-eye" />} </a>
                                    {errors.currentpassword && <span className="error">{errors.currentpassword}</span>}
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group pos-rel-change">
                                    <label>New Password <span>*</span></label>
                                    <sup className="password-type">(Password must be at least 8 characters, include uppercase, lowercase, number, and special character)</sup>
                                    <input type={showNewPassword ? "text" : "password"} className="input-fld" name="newpassword" value={formData.newpassword} onChange={handleChange} />
                                    <a className='see-password' onClick={() => setNewShowPassword((prev) => !prev)}> {showNewPassword ? <i className="nav-icon fas fa-eye-slash" /> : <i className="nav-icon fas fa-eye" />} </a>
                                    {errors.newpassword && <span className="error">{errors.newpassword}</span>}
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group pos-rel-change">
                                    <label>Confirm New Password <span>*</span></label>
                                    <input type="password" className="input-fld" name="confirmnewpassword" value={formData.confirmnewpassword} onChange={handleChange} />
                                    {errors.confirmnewpassword && <span className="error">{errors.confirmnewpassword}</span>}
                                        {/*{successMessage && <p className="suceess-msg" style={{ color: 'green' }}>{successMessage}</p>}
                                    {errorMessage && <p className="error-msg" style={{ color: 'red' }}>{errorMessage}</p>} */}
                                </div>
                            </div>
                            
                            <div className="col-12">
                                <button onClick={handleSubmit} className="btn btn-primary submit-btn">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>{/* /.container-fluid */}
            </section>

        </>
    );

}
export default ChangePassword;